import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { QuidelCoreModule, ActivityInterceptor, LoaderInterceptor } from './core';
import { AppRoutingModule } from './app-routing.module';

import { MsalModule, MsalInterceptor, MsalService, MsalRedirectComponent } from '@azure/msal-angular';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxSpinnerModule } from 'ngx-spinner';
import { provideNgxMatToast } from 'ngx-mat-toast';

import { PendingApprovalComponent } from './pending-approval/pending-approval.component';
import { UserBlockingCookiesComponent } from './user-blocking-cookies/user-blocking-cookies.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { UserModule } from './admin/user/user.module';
import { AssaysModule } from './admin/assays/assays.module';
import { FacilityModule } from './admin/facility/facility.module';
import { OrganizationModule } from './admin/organization/organization.module';
import { InstrumentsModule } from './admin/instruments/instruments.module';
import { PairedDevicesModule } from './admin/paired-devices/paired-devices.module';
import { OrphansModule } from './admin/orphans/orphans.module';
import { ReportsModule } from './reports/reports.module';
import { ResultsApiModule } from './admin/results-api/results-api.module';

@NgModule({
  declarations: [
    AppComponent,
    PendingApprovalComponent,
    UserBlockingCookiesComponent,
    ForbiddenComponent
  ],
  bootstrap: [AppComponent, MsalRedirectComponent], imports: [CommonModule,
    BrowserModule,
    AppRoutingModule,
    MsalModule,
    QuidelCoreModule,
    AssaysModule,
    FacilityModule,
    UserModule,
    OrganizationModule,
    InstrumentsModule,
    PairedDevicesModule,
    OrphansModule,
    ReportsModule,
    ResultsApiModule,
    NgxSpinnerModule,
    TranslateModule.forRoot({
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader(),
      isolate: true
    })],
  providers: [
    MsalService,
    provideNgxMatToast({
      position: { horizontal: 'center', vertical: 'bottom' },
      duration: 5000
    }),
    { provide: HTTP_INTERCEPTORS, useClass: ActivityInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ]
})
export class AppModule { }


